import React, { useState } from 'react';
import { List, ListItem, ListItemText } from '@material-ui/core';

interface MenuProps {
    onSelect: (section: string) => void;
}

const LicenseAdminMenu: React.FC<MenuProps> = ({ onSelect }) => {
    const [selectedItem, setSelectedItem] = useState<string>('latestReview');

    const handleSelect = (section: string) => {
        setSelectedItem(section);
        onSelect(section);
    };

    return (
        <List>
            <ListItem button selected={selectedItem === 'latestReview'} onClick={() => handleSelect('latestReview')}>
                <ListItemText primary="License reviews" />
            </ListItem>
            <ListItem button selected={selectedItem === 'manageReview'} onClick={() => handleSelect('manageReview')}>
                <ListItemText primary="Manage reviews" />
            </ListItem>
            <ListItem button selected={selectedItem === 'formConfig'} onClick={() => handleSelect('formConfig')}>
                <ListItemText primary="Configure review form" />
            </ListItem>
            <ListItem button selected={selectedItem === 'importData'} onClick={() => handleSelect('importData')}>
                <ListItemText primary="Import data manually" />
            </ListItem>
        </List>
    );
};

export default LicenseAdminMenu;